import React from "react";
import './BucketIcon.scss';

export default class BucketIcon extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            circlePer: this.props.circlePer.toString() != 'NaN' ? this.props.circlePer + '%' : "0%",
            values: "0;0",
            bar: false
        }
        this.goToId = this.goToId.bind(this);
    }
    componentDidUpdate(nextProps, prevprops) {

        const val = nextProps.circlePer.toString() != NaN ? nextProps.circlePer.toString() + '%' : "0%";
        if (this.state.circlePer.toString() != val) {
            this.setState({
                circlePer: val,
                startColor: nextProps.startColor,
                values: `0;${nextProps.circlePer.toString() != NaN ? nextProps.circlePer / 100 : 0}`
            }, () => {
                
            })
        }
    }
    getValue() {
        return this.state.values.indexOf("NaN") >= 0 ? "0;0" : this.state.values;
    }
    getCirclePer() {
        return this.state.circlePer.indexOf("NaN") >= 0 ? "0" : this.state.circlePer;
    }
    getId() {
        return this.props.name.replaceAll(" ", "");
    }
    getFillValue() {
        return `fil4`;
    }

    goToId(event){
        const id =  event.split("-")[0].trim();
        document.getElementById(id+"scroll").scrollIntoView({behavior:'smooth',block: "center"});
    }
    render() {

        return (
            <div className="bucketIcon">
                <div className="bucketsvg">
                    <svg xmlns="http://www.w3.org/2000/svg" space="preserve" width="300%" height="100%"
                        xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <linearGradient id={this.getId()} x1="0.5" y1="1" x2="0.5" y2="0">
                                <stop offset={this.getCirclePer()} stopOpacity="1" stopColor={this.state.startColor}>
                                    <svg>
                                        <animate attributeName="offset" values={this.getValue()} repeatCount="1" dur="2s" begin="0s" fill="freeze" />
                                    </svg>
                                </stop>
                                <stop offset="0%" stopOpacity="1" stopColor="white" />
                            </linearGradient>
                        </defs>
                        <path className="fil0"
                            d="M46.6991 104.524l0.1027 0c1.0905,-5.5013 28.0536,-9.9069 61.1482,-9.9069 33.0949,0 60.0575,4.4056 61.1481,9.9069l0.1031 0 -17.3713 130.172c-0.0025,0.1923 -0.0293,0.3829 -0.0765,0.5724l-0.0106 0.0792 -0.011 0c-1.5052,5.3436 -20.5335,9.5705 -43.7818,9.5705 -23.2482,0 -42.2767,-4.2271 -43.7822,-9.5705l-0.0103 0 -0.0101 -0.0749c-0.0483,-0.1913 -0.0745,-0.3835 -0.077,-0.5774l-17.3713 -130.171z" />

                        <path className="fil1" fill={`url(#${this.getId()})`}
                            d="M163.278 109.251l-8.2286 67.3497 -7.3293 54.9244c-0.0023,0.1741 -0.0265,0.3469 -0.0694,0.5187l-0.0096 0.072 -0.0099 0c-1.3643,4.8429 -18.6105,8.6742 -39.6816,8.6742 -21.071,0 -38.3174,-3.8315 -39.682,-8.6742l-0.0092 0 -0.0091 -0.0681c-0.044,-0.1734 -0.0676,-0.3475 -0.0699,-0.5233l-7.3279 -54.9104 -8.23 -67.3628c9.8067,3.4704 30.8961,5.8722 55.3281,5.8722 24.4328,0 45.5217,-2.402 55.3284,-5.8724z" />

                        <ellipse className="fil3" cx="107.95" cy="104.87" rx="61.1865" ry="10.253" />
                        <ellipse className="fil4" cx="107.95" cy="104.87" rx="55.4003" ry="8.86367" />


                        <path className="fil0"
                            d="M107.95 34.4816c35.1942,0 63.7357,27.7968 63.7357,62.073 0,5.9535 -0.8631,11.7099 -2.4714,17.16 0.9599,0.9094 1.6141,2.7033 1.6141,4.7672 0,2.9828 -1.3644,5.4015 -3.047,5.4015 -1.6826,0 -3.047,-2.4187 -3.047,-5.4015 0,-2.9826 1.3644,-5.4013 3.047,-5.4013 0.093,0 0.1847,0.0075 0.2754,0.022l1.1446 -8.5776 -0.0992 0c-0.1665,-0.8406 -0.9382,-1.656 -2.2423,-2.4336 0.1785,-1.8226 0.2736,-3.6685 0.2736,-5.5367 0,-26.4884 -18.3588,-48.8069 -43.3554,-55.5509 -0.8393,1.0812 -3.0191,1.8526 -5.5766,1.8526 -2.1837,0 -4.0927,-0.5627 -5.1264,-1.3996 -1.0338,0.8369 -2.9416,1.3996 -5.1251,1.3996 -2.1834,0 -4.0912,-0.5627 -5.125,-1.3996 -1.0337,0.8369 -2.9427,1.3996 -5.1264,1.3996 -2.555,0 -4.733,-0.77 -5.574,-1.8493 -24.9976,6.743 -43.358,29.0585 -43.358,55.5476 0,1.8682 0.0949,3.7143 0.2736,5.5369 -1.3041,0.7776 -2.0758,1.5928 -2.2421,2.4334l-0.0994 0 1.1446 8.5776c0.0907,-0.0145 0.1824,-0.022 0.2754,-0.022 1.6826,0 3.047,2.4187 3.047,5.4013 0,2.9828 -1.3644,5.4015 -3.047,5.4015 -1.6826,0 -3.047,-2.4187 -3.047,-5.4015 0,-2.0639 0.6542,-3.858 1.6141,-4.7674 -1.6086,-5.4501 -2.4714,-11.2066 -2.4714,-17.1598 0,-34.2762 28.5415,-62.073 63.7356,-62.073z" />


                    </svg>
                    <div className="valuecount"><p>{this.props.total == null ? 0 : this.props.total }</p></div>
                </div>
                <button className="btn" onClick={()=>this.goToId(this.props.name)}>{this.props.name}</button>
                <p style={{ fontSize: '16px', marginTop: "-10px"}}>{this.props.message}</p>
            
            </div>
        )
    }
}